import { FormField, MultiSelect, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { REQUIRED_LABEL } from "../snapshotUtils";
import PanoramaIcon from "@mui/icons-material/Panorama";

const CameraPositions = observer(() => {
	const store = useSnapshotTemplateStore();
	const {
		imageTypeIsTurntable, 
		selectedCameraPositions,
		setSelectedCameraPositions,
		cameraPositionOptions,
	} = store;
	if (imageTypeIsTurntable) {
		return null;
	}	
	return (
		<FormField
			control={(
				<MultiSelect
					ImageProps={{
						noImageComponent: <PanoramaIcon />,
					}}
					grouped
					limitTags={4}
					onChange={setSelectedCameraPositions}
					options={cameraPositionOptions}
					placeHolderRes="3DSelectCameraPositions"
					slimCard
					value={selectedCameraPositions}
				/>
			)}
			fullWidth
			label={<Text bold res="3DCameraPositions" />}
			labelPlacement="top"
			required
			sx={REQUIRED_LABEL}
		/>
	);
});

export default CameraPositions;
